import { Link } from "react-router-dom";
import { MapPin, User, Clock, AlertTriangle } from "lucide-react";
import { fmtDay, fmtTime } from "@/lib/format";
import { typeLabel } from "@/lib/interventions";
import { ItvPriority, ItvStatus, SlaBadge } from "@/components/interventions/ItvBadges";

export const ItvRow = ({ itv }) => (
  <li data-testid={`itv-row-${itv.id}`}>
    <Link to={`/interventi/${itv.id}`} className="flex flex-col gap-2 rounded-control px-3 py-3 transition-colors hover:bg-slate-50 md:flex-row md:items-center md:gap-4">
      <div className="w-full shrink-0 md:w-28">
        <p className="font-mono text-xs font-semibold text-ink">{itv.scheduled_at ? fmtTime(itv.scheduled_at) : "—"}</p>
        <p className="text-[11px] text-slate-500">{itv.scheduled_at ? fmtDay(itv.scheduled_at) : "Da pianificare"}</p>
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-ink"><span className="font-mono text-xs text-slate-400">{itv.number}</span> · {itv.title}</p>
        <p className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-slate-500">
          <span className="font-medium text-slate-700">{itv.company_name}</span>
          {itv.address && <span className="flex min-w-0 items-center gap-1"><MapPin className="h-3 w-3 shrink-0" /><span className="truncate">{itv.address}</span></span>}
          <span className="flex items-center gap-1"><User className="h-3 w-3" />{itv.lead_technician_name || "Non assegnato"}</span>
          <span>{typeLabel(itv.type)}</span>
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        {itv.late && <span className="flex items-center gap-1 text-xs font-semibold text-red-600" data-testid={`itv-late-${itv.id}`}><AlertTriangle className="h-3 w-3" />In ritardo</span>}
        <ItvPriority priority={itv.priority} />
        <SlaBadge itv={itv} testId={`itv-sla-${itv.id}`} />
        <ItvStatus status={itv.status} testId={`itv-status-${itv.id}`} />
      </div>
    </Link>
  </li>
);

export const ItvEmpty = ({ text = "Nessun intervento." }) => (
  <p className="flex items-center justify-center gap-2 py-10 text-sm text-slate-500" data-testid="itv-empty"><Clock className="h-4 w-4" />{text}</p>
);
